import React, { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import './App.scss';
import LoadingSpinner from './components/atoms/LoadingSpinner';
import GlobalStateProvider from './components/layouts/GlobalStateProvider';
import { CampaignRoutes } from './components/routing/routes/CampaignRoutes';
import './helpers/cookie-consent';
import './helpers/cookie-consent-customs';
import { useHistoryNavigation } from './hooks/useHistoryNavigation';

const App = () => {
  // custom hook - handle browser navigation
  const handleBrowserNavigation = () => {
    window.location.reload();
  };
  useHistoryNavigation(handleBrowserNavigation);
  return (
    <BrowserRouter>
      <HelmetProvider>
        <GlobalStateProvider>
          <Suspense fallback={<LoadingSpinner />}>
            <CampaignRoutes />
          </Suspense>
        </GlobalStateProvider>
      </HelmetProvider>
    </BrowserRouter>
  );
};

export default App;
